import {TypeAccountRoles} from '../../../shared/types/user-account.types';

export const TARIFF_CONNECT_ALLOWED_ROLES: TypeAccountRoles[] = [
  TypeAccountRoles.CUSTOMER,
  TypeAccountRoles.WORKER,
  TypeAccountRoles.MANAGER,
  TypeAccountRoles.PROJECT_MANAGER,
  TypeAccountRoles.DIRECTOR,
  TypeAccountRoles.FUNCTIONAL_ADMIN,
  TypeAccountRoles.ADMIN,
  TypeAccountRoles.OWNER,
];
